import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapLocationDot, faFutbol, faDumbbell } from "@fortawesome/free-solid-svg-icons";
import styles from "./Deporte.module.css"; // Asegúrate de crear y usar este archivo CSS

const deportes = [
  {
    nombre: "Club Atlético Vélez Sarsfield",
    ubicacion: "Av. Emilio Olmos - Esquina Alte. Brown",
    link: "https://maps.app.goo.gl/HrePUum7uba6CC1d9",
    telefonos: ["03532 - 15405072"],
    detalles: [
      { tipo: "POLIDEPORTIVO", desc: 'Polideportivo "Cristian Romero"', ubic: "Av. Emilio Olmos." },
      { tipo: "ESTADIO DE FÚTBOL", desc: "Estadio Rosario Vera", ubic: "Alte Brown." },
      { tipo: "NATATORIO", desc: 'Natatorio "Pablo Batata Filoni" Pileta Climatizada', ubic: "Alte Brown." },
    ],
  },
  {
    nombre: "Oliva Rugby Club",
    ubicacion: "Predio de la Sociedad Rural Oliva – Calle La Rioja 701",
    link: "https://maps.app.goo.gl/zdffoWcQR8QtKwRv6",
    telefonos: ["03532 - 15469038", "03532 - 15404199"],
  },
  {
    nombre: "Óvalo Municipal",
    ubicacion: "Predio del Ferrocarril – Ingreso por Calle Blvd Dr. R. Moyano 505",
    link: "https://maps.app.goo.gl/CUDxgJzKNa8Wrt1m8",
    descripcion:
      "El Óvalo Municipal es un espacio público al aire libre parquizado e iluminado, está ubicado en los predios del ferrocarril, es utilizado para diferentes disciplinas como lo son: Atletismos, Fútbol, Rugby, entre otros.",
  },
  {
    nombre: "Club de Cazadores y Pescadores de Oliva",
    ubicacion: "Ruta Nacional 9 Km.",
    link: "https://maps.app.goo.gl/7DwGQ3rnUjQtxQe7A",
  },
  {
    nombre: "Complejo de Padel Los Olmos",
    ubicacion: "Juan José Paso 641.",
    link: "https://maps.app.goo.gl/G4Y7wJJDfd5zd5JCA",
    telefonos: ["03532 - 15503165"],
  },
  {
    nombre: "Padel CAVS",
    ubicacion: "Av. Olmos (Club Vélez Sarsfield).",
    link: "https://maps.app.goo.gl/HrePUum7uba6CC1d9",
    telefonos: ["03532 - 15400401", "03532 - 15401054"],
  },
  {
    nombre: "Independiente Deportivo Social Club",
    ubicacion: "Av. Emilio Olmos 150",
    link: "https://maps.app.goo.gl/rHbR8Lb2nTUkPKmb7",
    telefonos: ["03532 - 420830"],
    detalles: [
      { tipo: "POLIDEPORTIVO", desc: "El Gigante", ubic: "Güemes 87." },
      { tipo: "ESTADIO DE FÚTBOL", desc: 'Estadio Rubén "TATI" Ciccarelli', ubic: "Roque Sáen Peña - Esquina Güémez ." },
      { tipo: "NATATORIO", desc: "Pileta al aire Libre - Natatorio de Verano", ubic: "Güemes 87." },
    ],
  },
  {
    nombre: "Paseo del Deporte “Presidente Dr. Raúl Ricardo Alfonsín”",
    ubicacion: "Ingreso por Calles 21 de agosto – Esquina Av. Emilio Olmos",
    link: "https://maps.app.goo.gl/fkiW4eHkt24Y9pUM9",
    descripcion:
      "El Paseo del Deporte está ubicado a la vera del acceso a la autopista, su ingreso comienza al finalizar el Paseo de la Virgen. Es una vía pública en donde pueden acceder bicicletas y peatones. El tramo completo tiene una distancia total de 5700mts., y posee dos pequeñas islas con diferentes equipamientos deportivos. Además, al recorrer este sitio se pueden observar múltiples plantaciones de árboles autóctonos, que embellecen el recorrido.",
  },
  {
    nombre: "La Cantina I.D.S.C (PADEL)",
    ubicacion: "Roque Sáez Peña – Rutan Nacional 9 – Club I.D.S.C",
    link: "https://maps.app.goo.gl/3ikmJ216YfysafQ99",
    telefonos: ["03532 - 15407017"],
  },
];

const Deporte = () => (
  <div className="content-tab">
    <div className="row">
      <div className="col-12 col-md-7">
        {deportes.slice(0, 6).map((dep, i) => (
          <div className={styles.deporteReferencias} key={i}>
            <h6>
              <FontAwesomeIcon icon={faFutbol} style={{ color: "#2980b9", marginRight: 6 }} />
              {dep.nombre}
            </h6>
            <p>
              <FontAwesomeIcon icon={faMapLocationDot} className="icon-deporte" style={{ color: "#16a085", marginRight: 4 }} />
              Ubicación: <a href={dep.link} target="_blank" rel="noopener noreferrer">{dep.ubicacion}</a>
            </p>
            {dep.telefonos && dep.telefonos.map((tel, idx) => (
              <p key={idx}>Teléfono: {tel}</p>
            ))}
            {dep.detalles && (
              <ul>
                {dep.detalles.map((d, idx) => (
                  <li key={idx}>
                    <strong>{d.tipo}:</strong> {d.desc}<br />
                    {d.ubic}
                  </li>
                ))}
              </ul>
            )}
            {dep.descripcion && <p>{dep.descripcion}</p>}
          </div>
        ))}
      </div>
      <div className="col-12 col-md-5">
        {deportes.slice(6).map((dep, i) => (
          <div className={styles.deporteReferencias} key={i}>
            <h6>
              <FontAwesomeIcon icon={faDumbbell} style={{ color: "#c0392b", marginRight: 6 }} />
              {dep.nombre}
            </h6>
            <p>
              <FontAwesomeIcon icon={faMapLocationDot} className="icon-deporte" style={{ color: "#16a085", marginRight: 4 }} />
              Ubicación: <a href={dep.link} target="_blank" rel="noopener noreferrer">{dep.ubicacion}</a>
            </p>
            {dep.telefonos && dep.telefonos.map((tel, idx) => (
              <p key={idx}>Teléfono: {tel}</p>
            ))}
            {dep.detalles && (
              <ul>
                {dep.detalles.map((d, idx) => (
                  <li key={idx}>
                    <strong>{d.tipo}:</strong> {d.desc}<br />
                    {d.ubic}
                  </li>
                ))}
              </ul>
            )}
            {dep.descripcion && <p>{dep.descripcion}</p>}
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default Deporte;